import rootReducer from 'redux/store/reducers'
import { configureStore } from '@reduxjs/toolkit'
import { ConfigurationsAPI } from 'redux/store/Configurations/ConfigurationsAPI'
import { UserInfoAPI } from './UserInfo/UserInfoAPI'
import { ProfileAPI } from './Profile/ProfileAPI'
import { UsersApi } from './users/UsersApi'
import { GlobalAPI } from './Global/GlobalAPI'
import { FlightAPI } from './Flight/FlightAPI'
import { GroupsAPI } from './Groups/GroupsAPI'
import { ReservationsAPI } from './Reservations/ReservationsAPI'
import {
  ClientsAPI,
  HotelOfferApi,
  HotelPricingApi,
  HotelsAPI,
  MarketPlaceAPI,
  PackagesAPI,
  RoomsApi,
  TransportationsAPI,
} from './actions'
import { CateringAPI } from './Catering/CateringAPI'

const store = configureStore({
  reducer: rootReducer, // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      UserInfoAPI.middleware,
      ProfileAPI.middleware,
      GlobalAPI.middleware,
      ConfigurationsAPI.middleware,
      FlightAPI.middleware,
      UsersApi.middleware,
      HotelsAPI.middleware,
      RoomsApi.middleware,
      HotelPricingApi.middleware,
      HotelOfferApi.middleware,
      TransportationsAPI.middleware,
      ClientsAPI.middleware,
      CateringAPI.middleware,
      GroupsAPI.middleware,
      PackagesAPI.middleware,
      ReservationsAPI.middleware,
      MarketPlaceAPI.middleware,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
})
export default store
export type AppDispatch = typeof store.dispatch
